import React, { createContext, useState, useEffect } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from "yup";
import NewWindow from 'react-new-window'
import moment from 'moment';
import _ from 'lodash';
import { Card, Form, Jumbotron, Col, Button } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../../controls/formControls';
import CustomerCodingEventService from '../../services/CustomerCodingEventService';
import { CustomerAccountService } from '../../services';

const monthPrevious = (last = false) => {
    var d = new Date();
    d.setDate(0);
    if (!last) {
        d.setDate(1);
    }
    return d;
}

const CustomerQAReport = (props) => {
    const [metrics, setMetrics] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [initFromDate, setInitFromDate] = useState(null);
    const [initToDate, setInitToDate] = useState(null);
    const [reportType, setReportType] = useImmer("5 STAR RATING ITEMS");
    const [assessmentTypes, setAssessmentTypes] = useImmer("SOC/ROC");
    const [selectedWorksheets, setSelectedWorksheets] = useImmer([9, 12]);
    const [selectedLocators, setSelectedLocators] = useImmer(["M0030", "M0032", "M0102", "M0104", "M1000", "M1005", "M1400", "M1830", "M1850", "M1860", "M2020"]);

    useEffect(() => {
        //const initFromDate = monthPrevious().toISOString().split('T')[0];
        //const initToDate = monthPrevious(true).toISOString().split('T')[0];
        const initFromDate = moment(new Date()).subtract(1, 'months').startOf('month').toISOString().split('T')[0];
        const initToDate = moment(new Date()).startOf('month').subtract(1, 'days').toISOString().split('T')[0]; // .subtract(1, 'months').endOf('month').subtract(1, 'days')
        setInitFromDate(initFromDate);
        setInitToDate(initToDate);
        getCustomerList();
    }, [])


    const assessmentMetricsValidationSchema = {
        selectedAccounts: Yup.array().min(1, 'You must select at least one account'),
        dateFrom: Yup.date().nullable().required('You must select a from date'),
        dateTo: Yup.date().nullable().required('You must select an end date').min(
            Yup.ref('dateFrom'), 'End date cannot be before start date.'
        )
    };

    const formik = useFormik({
        initialValues: { selectedAccounts: [], dateFrom: initFromDate, dateTo: initToDate },
        validationSchema: Yup.object().shape(assessmentMetricsValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            //await saveCustomer(values);
            await getMetrics(values);
            setSubmitting(false);
        }
    });

    const getCustomerList = async () => {
        const customerService = new CustomerCodingEventService();
        var results = await customerService.getCustomerRef(false, true);
        if (results.result) {
            let accounts = results.model.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
            let accountList = accounts.map((acc) => (
                {
                    value: acc.id,
                    label: acc.name
                }
            ));

            setCustomers(accountList);
            if (accountList.length === 1) {
                //formik.values.selectedAccounts.push(accountList[0].id);
                formik.setFieldValue('selectedAccounts', [accountList[0].value], true)
            }
        } else {
            alert("Failed to get customer list");
        }

    }

    const getMetrics = async (values) => {
        const { selectedAccounts, dateFrom, dateTo } = values;
        const codingEventService = new CustomerCodingEventService();
        var results = await codingEventService.assessmentQAReport(selectedAccounts, dateFrom, dateTo, selectedWorksheets, selectedLocators);
        if (results.result) {
            let metrics = results.model;
            metrics.accountResultsFlat = {};
            if (metrics.allResults.length > 0) {
                metrics.allResultsFlat = metrics.allResults.reduce((a, v) => ({ ...a, [v.identifier]: v }), {});
            }
            if (metrics.accountResults.length > 0) {
                metrics.accountResults.forEach(acc => {
                    const accMetFlat = acc.metrics.reduce((a, v) => ({ ...a, [v.identifier]: v }), {});
                    metrics.accountResultsFlat[acc.accountId] = accMetFlat;
                });
            }


            setMetrics(metrics);
        } else {
            alert("No results returned.");
        }
    }

    const changeReportType = (event) => {
        const value = event.target.value;
        setReportType(value);
        if (value == "5 STAR RATING ITEMS") {
            setSelectedLocators(["M0030", "M0032", "M0102", "M0104", "M1000", "M1005", "M1400", "M1830", "M1850", "M1860", "M2020"]);
        } else {
            setSelectedLocators(["M1033", "M1400", "M1700", "M1710", "M1800", "M1810", "M1820", "M1830", "M1840", "M1845", "M1850", "M1860", "M1870", "M2020"]);
        }
        //if (value == "5 STAR RATING ITEMS") {
        //    setSelectedLocators(["M0102", "M1242", "M1400", "M1830", "M1850", "M1860", "M2020"]);
        //} else {
        //    setSelectedLocators(["M0110", "M1030", "M1242", "M1311", "M1324", "M1334", "M1342", "M1400", "M1620", "M1630", "M1810", "M1820", "M1830", "M1840", "M1850", "M1860", "M2200"]);
        //}

    }

    const changeAssessmentTypes = (event) => {
        const value = event.target.value;
        setAssessmentTypes(value);
        if (value == "SOC/ROC") {
            setSelectedWorksheets([9, 12]);
        } else {
            setSelectedWorksheets([10, 11]);
        }

        //if (value == "SOC/ROC") {
        //    setSelectedWorksheets([1, 7, 9, 12]);
        //} else {
        //    setSelectedWorksheets([5, 6, 10, 11]);
        //}
    }

    const showAllMetrics = () => {
        return (
            <tr>
                <td>Total</td>
                <td>{metrics.allResults[0].cnt}</td>
                {
                    selectedLocators.map(loc => {
                        return renderMetric(metrics.allResultsFlat[loc]?.compliance, metrics.allResultsFlat[loc]?.compliance, loc);
                    })
                }
            </tr>
        )
    }

    const renderMetric = (stand, metric, id = '') => {
        const color = stand > metric ? { backgroundColor: "red", color: "white", padding: "3px 6px", width: "100%", borderRadius: "6px", textAlign: "center" } :
            stand < metric ? { backgroundColor: "palegreen", padding: "3px 6px", width: "100%", borderRadius: "6px", textAlign: "center" } :
                undefined;
        if (stand != NaN && stand != undefined && metric != NaN && metric != undefined) {
            if (color) {
                return <td><span style={color}>{parseInt(metric * 100)}%</span></td>
            } else {
                return <td><span style={{ padding: "3px 6px", width: "100%", textAlign: "center" }}>{parseInt(metric * 100)}%</span></td>
            }
        } else {
            return <td><span style={{ padding: "3px 6px", width: "100%", textAlign: "center" }}>n/a</span></td>;
        }
    }

    const showClinicalManagerMetrics = () => {

        let clinicalManagers = [];
        if (metrics.accountResults) {
            metrics.accountResults.forEach(acc => {
                if (acc.clinicalManagerResults?.length > 0) {
                    acc.clinicalManagerResults.forEach(cm => {
                        clinicalManagers.push(cm);
                    })
                }
            });
        }
        if (clinicalManagers.length > 0) {
            //const accData = accountResults.reduce((a, v) => ({ ...a, [v.name]: v.data.accountResults[0].locatorMetrics.reduce((b, w) => ({ ...b, [w.identifier]: w.compliance })) }));
            //return JSON.stringify(accData, null, 2);
            clinicalManagers = clinicalManagers.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
        }

        return clinicalManagers.map(cm => {
            //if (metrics.allResults) {
                
            //    //curMetrics = metrics.allResults.reduce((obj, item) => (obj[item.identifier] = item, obj) ,{});
            //} else if (metrics.accountResults) {
            //    curMetrics = metrics.accountResults[cm.accountId];
            //}

            var allMetrics = metrics.allResultsFlat ? metrics.allResultsFlat : metrics.accountResultsFlat[cm.accountId];
            var clinManMetrics = cm.metrics.reduce((obj, item) => (obj[item.identifier] = item, obj), {}); // Object.entries(cm.metrics)

            return (
                <tr>
                    <td className="fit-content">{cm.name}</td>
                    <td>{cm.metrics[0].cnt}</td>
                    {
                        selectedLocators?.map(loc => {
                            return renderMetric(allMetrics[loc]?.compliance, clinManMetrics[loc]?.compliance, loc);
                        })
                    }
                </tr>
            )
        })
    }

    const showClinicianMetrics = () => {

        let clinicianResults = [];
        if (metrics.accountResults) {
            metrics.accountResults.forEach(acc => {
                if (acc.clinicianResults?.length > 0) {
                    acc.clinicianResults.forEach(c => {
                        clinicianResults.push(c);
                    })
                }
            });
        }
        if (clinicianResults.length > 0) {
            //const accData = accountResults.reduce((a, v) => ({ ...a, [v.name]: v.data.accountResults[0].locatorMetrics.reduce((b, w) => ({ ...b, [w.identifier]: w.compliance })) }));
            //return JSON.stringify(accData, null, 2);
            clinicianResults = clinicianResults.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);
        }

        return clinicianResults.map(c => {


            var allMetrics = metrics.allResultsFlat ? metrics.allResultsFlat : metrics.accountResultsFlat[c.accountId];

            var clinMetrics = c.metrics.reduce((obj, item) => (obj[item.identifier] = item, obj), {}); // Object.entries(cm.metrics)
            return (
                <tr>
                    <td className="fit-content">{c.name}</td>
                    <td>{c.metrics[0].cnt}</td>
                    {
                        selectedLocators?.map(loc => {
                            return renderMetric(allMetrics[loc]?.compliance, clinMetrics[loc]?.compliance, loc);
                        })
                    }
                </tr>
            )
        })
    }

    const showAccountMetrics = () => {
        //return JSON.stringify(accountResults[0].data.accountResults[0].locatorMetrics, null, 2)
        //const sumRes = sumResults?.reduce((a, v) => ({ ...a, [v.identifier]: v}), {})       
        return metrics.accountResults.map(acc => {

            var accMetrics = acc.metrics.reduce((obj, item) => (obj[item.identifier] = item, obj), {});
            return (
                <tr>
                    <td className="fit-content">{acc.accountName}</td>
                    <td>{acc.metrics[0].cnt}</td>
                    {
                        
                        selectedLocators.map(loc => {
                            return renderMetric(metrics.allResultsFlat ? metrics.allResultsFlat[loc]?.compliance : accMetrics[loc]?.compliance, accMetrics[loc]?.compliance)
                        })
                    }
                </tr>
            )
        })
    }

    const clearMetrics = () => {
        setMetrics(null);
    }

    return (
        <Card className="h-80">
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Assessment Metrics</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                <Jumbotron className="pt-3 pb-2">
                    <Form.Row>
                        <Form.Group as={Col} lg="6" md="12">
                            <FormControls.Multiselect
                                options={customers}
                                name="selectedAccounts"
                                label="Accounts"
                                formHandler={formik}
                            />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="Start Date"
                                type="date"
                                name="dateFrom"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="3" md="12">
                            <FormControls.Textbox
                                label="End Date"
                                type="date"
                                name="dateTo"
                                formHandler={formik} />
                        </Form.Group>
                        <Form.Group as={Col} lg="4" md="6">
                            <Form.Label>Report Type</Form.Label>
                            <Form.Control as="select"
                                value={reportType}
                                onChange={(e) => changeReportType(e)}
                                name={reportType}>
                                <option>5 STAR RATING ITEMS</option>
                                <option>PDGM/VBP Financial Impact Items</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} lg="4" md="6">
                            <Form.Label>Assessment Type</Form.Label>
                            <Form.Control as="select"
                                value={assessmentTypes}
                                onChange={(e) => changeAssessmentTypes(e)}
                                name={assessmentTypes}>
                                <option>SOC/ROC</option>
                                <option>Recert/Other</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} lg="12" md="12">
                            <Button variant="success" onClick={() => formik.submitForm()}>Run</Button>
                        </Form.Group>
                    </Form.Row>
                </Jumbotron>
                <ConditionalRender visible={metrics}>
                    <NewWindow
                        title={reportType + " - " + assessmentTypes + " - " + formik.values.dateFrom + " to " + formik.values.dateTo}
                        onUnload={clearMetrics}
                        center="parent"
                        closeOnUnmount
                        features="{menubar=yes}"                    >
                        <div style={{ textAlign: "center" }}><h5>{reportType}</h5>{formik.values.dateFrom} - {formik.values.dateTo}</div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Locations</th>
                                    <th>{assessmentTypes}</th>
                                    {
                                        selectedLocators.map(loc => {
                                            return <th>{loc}</th>
                                        })
                                    }
                                </tr>
                            </thead>
                            {
                                metrics?.allResults?.length > 0 && showAllMetrics()
                            }
                            {
                                metrics?.accountResults?.length > 0 && showAccountMetrics()
                            }
                            <thead>
                                <tr>
                                    <th>Clinical Managers</th>
                                    <th>{assessmentTypes}</th>
                                    {
                                        selectedLocators.map(loc => {
                                            return <th>{loc}</th>
                                        })
                                    }
                                </tr>
                            </thead>
                            {
                                metrics?.accountResults?.length > 0 && showClinicalManagerMetrics()
                            }
                            <thead>
                                <tr>
                                    <th>Clinicians</th>
                                    <th>{assessmentTypes}</th>
                                    {
                                        selectedLocators.map(loc => {
                                            return <th>{loc}</th>
                                        })
                                    }
                                </tr>
                            </thead>
                            {
                                metrics?.accountResults?.length > 0 && showClinicianMetrics()
                            }
                        </table>
                    </NewWindow>
                </ConditionalRender>
            </Card.Body>
        </Card>
    )
}

export default CustomerQAReport;